import { WindowFeatures } from './types';

export function serializeFeatures(
  features: WindowFeatures | undefined,
): string | undefined {
  if (!features) {
    return undefined;
  }

  const keyValuePairs = Object.keys(features).reduce((acc, key) => {
    const value = features[key];

    if (value === true) {
      acc.push(key);
    } else if (value === false) {
      return acc;
    } else {
      acc.push(`${key}=${features[key]}`);
    }
    return acc;
  }, [] as string[]);

  return keyValuePairs.join(',');
}
